import "./fileUploadErrorModal.scss";
import iconError from "images/iconError.svg";
import cross from "images/cross.svg";
import { Modal } from "react-bootstrap";
import {
  documentExtensions,
  imageExtensions,
  MAX_FILE_SIZE_MB
} from "utils/consts";

const FileUploadErrorModal = ({ ...props }) => {
  return (
    <Modal {...props} centered dialogClassName="errorModal" aria-labelledby="contained-modal-title-vcenter" backdrop="static">
      <Modal.Body>
        <img src={cross} className="signin-img" onClick={props.onHide} alt="" />
        <div className="errorModal-header">
          <img src={iconError} alt="" className="errorModal-header__imgIcon" />
          <div className="errorModal-header__title">Не удалось загрузить файл, неверный формат.</div>
        </div>
        <div className="errorModal-content">
          <div className="errorModal-content__list-header">Ограничения по загружаемым файлам:</div>
          <ul className="errorModal-content__list">
            <li>Файл не должен превышать {MAX_FILE_SIZE_MB} МБ.</li>
            <li>Картинки: {imageExtensions.join(", ")}</li>
            <li>Документы: {documentExtensions.join(", ")}</li>
          </ul>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default FileUploadErrorModal;
